const state = {
    statusEdit: null,
    statusDelete: null
}
export default state